const ACTIONS = {
  GET: 'get',
  GET_EXTRA: 'get_extra',
  DELETE: 'delete',
  INSERT: 'insert',
  UPDATE: 'update',
  COMPLETE: 'complete',
  DUPLICATE: 'duplicate',
}
export { ACTIONS }
